import { render, staticRenderFns } from "./WipProductForm.vue?vue&type=template&id=6cf1757d&scoped=true&"
import script from "./WipProductForm.vue?vue&type=script&lang=ts&"
export * from "./WipProductForm.vue?vue&type=script&lang=ts&"
import style0 from "./WipProductForm.vue?vue&type=style&index=0&id=6cf1757d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf1757d",
  null
  
)

export default component.exports